import { Field } from 'formik'
import React from 'react'
import InputContainer from '../InputContainer'
import InputLabel from '../InputLabel'

function NumberInput({ field, ...rest }) {

    return (
        <InputContainer>
            <InputLabel text={field.prompt} htmlfor={field.name}/>
            <Field type="number" id={field.name} name={field.name} className=" p-3 border border-gray-500" />
        </InputContainer>
    )
}

export default NumberInput